var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"ex-link clearfix",attrs:{"href":_vm.props.data.url,"target":"_blank"}},[_c('i',{staticClass:"fa fa-external-link fa-2x"}),_vm._v("\n    "+_vm._s(_vm.props.data.content)+"\n    "),_c('br'),_c('small',[_vm._v("("+_vm._s(_vm.props.data.url)+")")])])}
var staticRenderFns = []

export { render, staticRenderFns }